<template>
	<v-layout row wrap align-center class="form-step-one">
		<v-flex xs12>
			<v-layout row wrap primary class="form-step-one-opacity">
				<v-flex xs12>
					<img
						src="/static/images-new/logos/logo-casamarket-white-mini.svg"
						alt="logo casamarket"
						height="64"
					/>
				</v-flex>
				<v-flex xs12>
					<h2 class="white--text w-black form-step-one-title">
						¡COMIENZA A VENDER <span>AHORA!</span>
					</h2>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 class="form-step-one-container">
			<v-btn
				class="form-step-one-btn ma-0"
				color="newprimary"
				depressed
				@click="$emit('on-click')"
			>
				Quiero vender
			</v-btn>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: 'form-step-one',
	};
</script>

<style lang="scss" scoped>
	.form-step-one {
		height: 91%;
		left: 17px;
		position: absolute;
		top: 19px;
		width: 91%;

		&-title {
			font-size: size(large31);
			letter-spacing: normal;
			line-height: normal;
			margin: 28px auto 41px;
			max-width: 210px;

			span {
				font-size: size(big39);
			}
		}

		&-btn {
			border-radius: 5px;
			color: color(white);
			font-size: size(medium18);
			font-weight: weight(black);
			height: 64px;
			width: 205px;
		}

		&-container {
			bottom: 255px;
			position: relative;
			z-index: 1;
		}

		&-opacity {
			height: 100%;
			opacity: .96;
			padding: 229px 0px 259px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/form-step-one.vue